import { useNavigate } from "react-router-dom";
import {
    Loader2,
    CheckCircle2,
    Clock3,
    XCircle,
    Ban,
} from "lucide-react";

import "./DeliveryTable.css";

import getImageUrl from "../../../utils/imageUrl";

function DeliveryTable({
    partners,
    loading,
}) {

    const navigate = useNavigate();

    const getStatusBadge = (status) => {

        switch (status) {

            case "Approved":
                return (
                    <span className="delivery-status approved">
                        <CheckCircle2 size={14} />
                        Approved
                    </span>
                );

            case "Pending":
                return (
                    <span className="delivery-status pending">
                        <Clock3 size={14} />
                        Pending
                    </span>
                );

            case "Rejected":
                return (
                    <span className="delivery-status rejected">
                        <XCircle size={14} />
                        Rejected
                    </span>
                );

            case "Suspended":
                return (
                    <span className="delivery-status suspended">
                        <Ban size={14} />
                        Suspended
                    </span>
                );

            default:
                return (
                    <span className="delivery-status">
                        Unknown
                    </span>
                );

        }

    };

    if (loading) {

        return (

            <div className="table-loading">

                <Loader2
                    className="spin"
                    size={42}
                />

                <p>Loading Delivery Partners...</p>

            </div>

        );

    }

    if (!partners.length) {

        return (

            <div className="table-empty">

                <h2>No Delivery Partners Found</h2>

            </div>

        );

    }

    return (

        <div className="delivery-table-container">

            <table className="delivery-table">

                <thead>

                    <tr>

                        <th>Partner</th>
                        <th>Phone</th>
                        <th>Vehicle</th>
                        <th>Vehicle No.</th>
                        <th>City</th>
                        <th>Status</th>
                        <th>Online</th>
                        <th>Available</th>
                        <th>Joined</th>
                        <th>Action</th>

                    </tr>

                </thead>

                <tbody>

                    {partners.map((partner) => {

                       const image = partner.profile?.photo
    ? getImageUrl(
        `/uploads/delivery/${partner.profile.photo}`
    )
    : "/images/default-user.png";

                        return (

                            <tr key={partner._id}>

                                <td>

                                    <div className="partner-info">

                                      <img
    src={image}
    alt={
        partner.userId?.name ||
        "Delivery Partner"
    }
    className="partner-avatar"
    onError={(e) => {
        e.currentTarget.src =
            "/images/default-user.png";
    }}
/>

                                        <div>

                                            <h4>
                                                {partner.userId?.name}
                                            </h4>

                                            <span>
                                                {partner.userId?.email}
                                            </span>

                                        </div>

                                    </div>

                                </td>

                                <td>
                                    {partner.userId?.phone || "-"}
                                </td>

                                <td>
                                    {partner.vehicle?.vehicleType || "-"}
                                </td>

                                <td>
                                    {partner.vehicle?.vehicleNumber || "-"}
                                </td>

                                <td>
                                    {partner.address?.city || "-"}
                                </td>

                                <td>
                                    {getStatusBadge(
                                        partner.work?.status
                                    )}
                                </td>

                                <td>

                                    <span
                                        className={
                                            partner.work?.online
                                                ? "online"
                                                : "offline"
                                        }
                                    >
                                        {partner.work?.online
                                            ? "Online"
                                            : "Offline"}
                                    </span>

                                </td>

                                <td>

                                    <span
                                        className={
                                            partner.work?.available
                                                ? "available"
                                                : "busy"
                                        }
                                    >
                                        {partner.work?.available
                                            ? "Available"
                                            : "Busy"}
                                    </span>

                                </td>

                                <td>

                                    {new Date(
                                        partner.createdAt
                                    ).toLocaleDateString("en-IN")}

                                </td>

                                <td>

                                    <button
                                        className="view-details-btn"
                                        onClick={() =>
                                            navigate(
                                                `/admin/delivery/${partner._id}`
                                            )
                                        }
                                    >
                                        View Details
                                    </button>

                                </td>

                            </tr>

                        );

                    })}

                </tbody>

            </table>

        </div>

    );

}

export default DeliveryTable;